<template>
  <div>
    <v-row class="pt-3 pb-2">
      <v-col cols="12">
      <div class="blue-grey lighten-4  rounded " @click="showDetailList">
        <v-row>
          <v-col cols="7">
            <span class="text-h6 ml-2">{{name}}</span>
          </v-col>
          <v-col cols="5" class="text-right">
            <span class="text-h6  mr-2">{{amount}} m3</span>
          </v-col>
        </v-row>
      </div>
      
      </v-col>
    </v-row>
    <div v-if ="showCards" class="mt-2">
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn
              text color="primary"
              @click="toExcel">
              {{ t.toExcel }}
            </v-btn>
          </v-col>
        </v-row>
        <div
          v-for="(beton, index) in betonlist"
          :key="beton.PrimarniKljuc"
          @click="openUtrosci(beton)"
          :style="canUtrosak ? 'cursor: pointer' : ''"
        >
          <BetonCard
            :kupac="beton.Kupac"
            :kolicina="beton.Kolicina"
            :gradiliste="beton.Gradiliste"
            :vozac="beton.Vozac"
            :receptura="beton.Receptura"
            :datum="beton.Datum.substr(0,10)"
            :vrijeme="beton.Vrijeme.substr(0,5)"
            :index="index"
            :brojotpremnice="beton.BrojOtpremnice"
            :storno="beton.Storno"
          />
        </div>
      </div>

    <!-- Dialog: Utrošci za otpremnicu -->
    <v-dialog v-model="dialogUtrosci" max-width="900">
      <v-card v-if="selectedBeton">
        <v-card-title class="blue lighten-4">
          {{ t.materialConsumption }} - OTP{{ parseInt(selectedBeton.BrojOtpremnice) }}
          <v-spacer></v-spacer>
          <v-btn text small color="primary" @click="utrosciToExcel(selectedBeton)">{{ t.toExcel }}</v-btn>
          <v-btn icon @click="dialogUtrosci = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-row class="mb-2">
            <v-col cols="12" sm="4"><b>{{ t.recipe }}:</b> {{ selectedBeton.Receptura }}</v-col>
            <v-col cols="12" sm="4"><b>{{ t.quantity }}:</b> {{ localMoney(selectedBeton.Kolicina) }} m3</v-col>
            <v-col cols="12" sm="4"><b>{{ t.date }}:</b> {{ localDate(selectedBeton.Datum) }}</v-col>
            <v-col cols="12" sm="4"><b>{{ t.customer }}:</b> {{ selectedBeton.Kupac }}</v-col>
            <v-col cols="12" sm="4"><b>{{ t.constructionSite }}:</b> {{ selectedBeton.Gradiliste }}</v-col>
            <v-col cols="12" sm="4"><span v-if="selectedBeton.Storno" class="red--text font-weight-bold">{{ t.storno }}</span></v-col>
          </v-row>

          <div v-for="grupa in utrosciGrupeZa(selectedBeton)" :key="grupa.naziv">
            <div v-if="grupa.stavke.length" class="mt-3">
              <div class="text-subtitle-1 font-weight-bold">{{ grupa.naziv }}</div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">{{ t.article }}</th>
                      <th class="text-left">{{ t.codeShort }}</th>
                      <th class="text-right">{{ t.targetShort }}</th>
                      <th class="text-right">{{ t.dosedShort }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(s, i) in grupa.stavke" :key="i">
                      <td>{{ s.naziv }}</td>
                      <td>{{ s.sifra }}</td>
                      <td class="text-right">{{ localMoney(s.zadano) }}</td>
                      <td class="text-right">{{ localMoney(s.dozirano) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>

          <div class="mt-3">
            <div class="text-subtitle-1 font-weight-bold">{{ t.water }}</div>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-right">{{ t.targetShort }}</th>
                    <th class="text-right">{{ t.dosedShort }}</th>
                    <th class="text-right">{{ t.waterAdded }}</th>
                    <th class="text-right">{{ t.waterCorrection }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-right">{{ localMoney(selectedBeton.VodaZadano) }}</td>
                    <td class="text-right">{{ localMoney(selectedBeton.VodaDozirano) }}</td>
                    <td class="text-right">{{ localMoney(selectedBeton.VodaNaknadno) }}</td>
                    <td class="text-right">{{ localMoney(selectedBeton.VodaKorekcija) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import BetonService from '@/services/BetonService'
import BetonCard from './BetonCard.vue'
import {dynamicSort} from "../../snippets/allSnippets"
import moneyFormat from '@/snippets/moneyFormat'
import { utrosciRows, utrosciColumns, otpremniceColumns, otpremniceRows } from '@/snippets/betonUtrosci'
import { betonT } from '@/snippets/betonLang'
import xlsx from 'json-as-xlsx'

export default {
  name: 'betonsingle',
  props: ['name', 'amount', 'odDatuma', 'doDatuma', 'sifraObjekta', 'kupac', 'gradiliste', 'refreshSignal'],
  data () {
    return {
      msg: '',
      lang: {},
      langC: {},
      locMonths: [],
      locYears: [],
      saving: false,
      postNew: false,
      query: {},
      betonlist: [],
      showCards: false,
      dialogUtrosci: false,
      selectedBeton: null,
    }
  },
  mounted () {

  },
  methods: {
    detalji() {
      console.log('Klikam na red')
    },
    async showDetailList () {
      this.showCards = !this.showCards
      if (this.showCards) {
        await this.loadBetonlist()
      }
    },
    async loadBetonlist () {
      this.query.TvrtkaID = this.$store.state.user.tvrtkaID ? this.$store.state.user.tvrtkaID : false
      this.query.qType = "Detail"
      this.query.OdDatuma = this.odDatuma
      this.query.DoDatuma = this.doDatuma
      this.query.ObjekatID = this.sifraObjekta
      if (this.kupac) {
        this.query.Kupac = this.kupac
      }
      if (this.gradiliste) {
        this.query.Gradiliste = this.gradiliste
      }
      // spriječi keširanje (svaki put svjež dohvat)
      this.query._t = new Date().getTime()

      await BetonService.choose(this.query)
      .then(res => {
        if (res && res.data && res.data.betoni) {
          this.betonlist = res.data.betoni
          this.betonlist.sort(dynamicSort("Datum"))
        }
      })
      .catch(err => {
        console.log('Error ', err )
      })
    },
     localDate(dateToFormat) {
      return this.$moment(dateToFormat).format('DD.MM.YYYY')
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    openUtrosci(beton) {
      if (!this.canUtrosak) return
      this.selectedBeton = beton
      this.dialogUtrosci = true
    },
    utrosciGrupeZa(beton) {
      return [
        { naziv: this.t.aggregates, stavke: this.napuniGrupu(beton, 'Agr', 8) },
        { naziv: this.t.cements, stavke: this.napuniGrupu(beton, 'Cem', 6) },
        { naziv: this.t.additives, stavke: this.napuniGrupu(beton, 'Adi', 6) }
      ]
    },
    utrosciToExcel(beton) {
      if (!beton) return
      const lang = this.$store.state.language
      const t = betonT(lang)
      const broj = parseInt(beton.BrojOtpremnice)
      const data = [
        {
          sheet: t.sheetDeliveryNote,
          columns: otpremniceColumns(lang),
          content: otpremniceRows([beton], this.localDate, lang)
        },
        {
          sheet: t.sheetMaterialConsumption,
          columns: utrosciColumns(lang),
          content: utrosciRows([beton], this.localDate, lang)
        }
      ]
      xlsx(data, { fileName: t.deliveryNote + '_' + broj, extraLength: 3, writeOptions: {} })
    },
    // pretvori prefiks (Agr/Cem/Adi) i broj komponenti u listu stavki s podacima
    napuniGrupu(beton, prefix, count) {
      const stavke = []
      if (!beton) return stavke
      for (let i = 1; i <= count; i++) {
        const naziv = beton[`${prefix}${i}NazivArtikla`]
        const sifra = beton[`${prefix}${i}SifraArtikla`]
        const zadano = parseFloat(beton[`${prefix}${i}Zadano`]) || 0
        const dozirano = parseFloat(beton[`${prefix}${i}Dozirano`]) || 0
        if ((naziv && naziv.trim() !== '') || zadano !== 0 || dozirano !== 0) {
          stavke.push({ naziv: naziv || '', sifra: sifra || '', zadano, dozirano })
        }
      }
      return stavke
    },
    toExcel() {
      if (this.betonlist) {
        const lang = this.$store.state.language
        const t = betonT(lang)
        const period = this.odDatuma === this.doDatuma ? this.localDate(this.odDatuma) : this.localDate(this.odDatuma) + '-' + this.localDate(this.doDatuma)
        const fileNm = (this.name ? this.name : t.sheetDeliveryNotes) + '_' + period

        // sheet "Delivery notes" + total red (stornirane se ne broje)
        const rows = otpremniceRows(this.betonlist, this.localDate, lang)
        let total = 0
        this.betonlist.forEach(item => { if (!item.Storno) total += parseFloat(item.Kolicina) || 0 })
        rows.push({ kupac: '', brojotpremnice: '', kolicina: total, gradiliste: '', vozac: '', regOzn: '', receptura: '', sifraArtikla: '', mixingTime: '', storno: '' })

        let data = [
          {
            sheet: t.sheetDeliveryNotes,
            columns: otpremniceColumns(lang),
            content: rows
          }
        ]
        if (this.canUtrosak) {
          data.push({
            sheet: t.sheetMaterialConsumption,
            columns: utrosciColumns(lang),
            content: utrosciRows(this.betonlist, this.localDate, lang)
          })
        }
        xlsx(data, { fileName: fileNm, extraLength: 3, writeOptions: {} })
      }
    }

  },
  computed: {
    t () {
      return betonT(this.$store.state.language)
    },
    canUtrosak () {
      const u = this.$store.state.user
      return !!(u && (u.betonUtrosak || u.admin1))
    }
  },
  watch: {
    refreshSignal () {
      if (this.showCards) {
        this.loadBetonlist()
      }
    }
  },
  components: {
    BetonCard
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
